import { Separator } from "@radix-ui/react-context-menu";

import { separator } from "../../css/menu";
import { styled } from "../../theme/stitches";

export const ContextMenuSeparator = styled(Separator, separator);
